import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ManagerSidebar from '../components/Sidebar/ManagerSidebar';
import DashboardHome from '../dashboards/Manager/DashboardHome';
import Tenants from '../dashboards/Manager/Lists/TenantsList';
import Maintenance from '../dashboards/Manager/Maintenance';
import './Home.css';

const ManagerDashboard = () => (
  <div className="app-layout">
    <ManagerSidebar />
    <div className="content">
      <style>{`
        .app-layout {
          display: flex;
          align-items: flex-start;
          margin-top: 0 !important;
          padding-top: 0 !important;
        }
        .content {
          flex-grow: 1;
          padding: 0 20px 20px 20px; /* Top padding set to 0 */
          margin-top: 0 !important;
        }
      `}</style>
      <Routes>
        <Route path="/" element={<DashboardHome />} />
        <Route path="tenants" element={<Tenants />} />
        <Route path="maintenance" element={<Maintenance />} />
        <Route path="appartUnites" element={<Maintenance />} />
        <Route path="Materials" element={<Maintenance />} />
        <Route path="finance" element={<Maintenance />} />
      </Routes>
    </div>
  </div>
);

export default ManagerDashboard;